import { render, staticRenderFns } from "./goods-detail.vue?vue&type=template&id=06680299&scoped=true&"
import script from "./goods-detail.vue?vue&type=script&lang=js&"
export * from "./goods-detail.vue?vue&type=script&lang=js&"
import style0 from "./goods-detail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./goods-detail.vue?vue&type=style&index=1&id=06680299&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06680299",
  null
  
)

export default component.exports